import { ReactComponent } from "/builds/mb/front/src/app/assets/images/menuClose.svg?react";
import url from "/builds/mb/front/src/app/assets/images/menuClose.svg?url";
export { ReactComponent };
export default url;
